<template>
  <div>
    <div>Tìm thấy <b class="text-danger">{{ count }}</b> tin nhắn nghi ngờ vi phạm, <a href="javascript:;"
                                                                                       @click="show"><i>xem chi tiết</i></a>
    </div>
    <b-modal v-model="showDetailModel" size="xl" ok-only :title="$t('chats')">
      <div class="c-smart-table tile" style="
    max-height: 500px;
    overflow-y: auto;
">
        <div class="row c-smart-table__title">
          <div class="col-lg-2"></div>
          <div class="col-lg-2">{{ $t('customer') }}</div>
          <div class="col-lg-2">{{ $t('user') }}</div>
          <div class="col-lg-2">{{ $t('createTime') }}</div>
          <div class="col-lg-4">{{ $t('content') }}</div>
        </div>
        <div class="row" v-for="item in data.messages" :key="item._id">
          <div class="col-lg-2">
            <div v-if="item.message && item.message.fromContact">
              <font-awesome-icon class="text-success" size="2x" icon="sign-in-alt" />
              <br />
              {{ $t('incomingMessage') }}
            </div>
            <div v-else>
              <font-awesome-icon class="text-success" size="2x" icon="sign-out-alt" />
              <br />
              {{ $t('outgoingMessage') }}
            </div>
          </div>
          <div class="col-lg-2">
            <p>
              <b>{{ $t('name') }}: </b>
              <span v-if="item.message && item.message.customer">{{ item.message.customer.name }}</span>
              <span v-else>{{ $t('unknown') }}</span>
            </p>
            <p>
              <b>{{ $t('source') }}: </b>
              <span v-if="item.message && item.message.source">{{ item.message.source.charAt(0).toUpperCase() + item.message.source.slice(1) }}</span>
              <span v-else>{{ $t('unknown') }}</span>
            </p>
          </div>
          <div class="col-lg-2">
            <div v-if="item.message && item.message.user">{{ item.message.user.name }}</div>
            <div v-else>{{ $t('unknown') }}</div>
          </div>
          <div class="col-lg-2">
            <p v-if="item.message && item.message.createTime">
              <span>{{ item.message.createTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
            </p>
          </div>
          <div class="col-lg-4">
            <p v-if="item.content">
              <span v-html="getContent(item)"></span>
            </p>
            <p v-else>{{ $t('unknown') }}</p>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary" @click="showDetailModel = false">{{ $t('close') }}</button>
        <button @click="del(data._id)" type="button"
                v-if="['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'am'].includes($store.state.user.role)"
                class="btn btn-danger mr-1">
          <font-awesome-icon icon="window-close" />&nbsp;{{ $t('skip') }}
        </button>
        <button @click="approved(data._id)" type="button"
                v-if="['owner', 'admin', 'account', 'accountant'].includes($store.state.user.role)"
                class="btn btn-warning mr-1">
          <font-awesome-icon icon="check" />&nbsp;{{ $t('lock') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ['id', 'count'],
  data() {
    return {
      service: '/fault-detection-chat',
      showDetailModel: false,
      data: []
    }
  },
  methods: {
    approved: function(id) {
      this.$swal({
        title: this.$t('lockClient'),
        icon: 'info',
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.$service.post(this.service + '/approved/' + id).then(response => {
            if (response.data) {
              this.$swal({
                title: this.$t('lockSuccess'),
                icon: 'success'
              })
              this.$bus.$emit('faultDetectionChat')
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                title: this.$t('error'),
                text: error.response.data.message,
                icon: 'error'
              })
            }
          })
        }
      })
    },
    del: function(id) {
      this.$swal({
        title: this.$t('deleteConfirm'),
        icon: 'warning',
        showCancelButton: true
      }).then((result) => {
        if (result.isConfirmed) {
          let loader = this.$loading.show()
          this.$service.delete(this.service + '/' + id + '?ignore=' + result.value).then(response => {
            if (response.data) {
              this.showDetailModel = false
              this.$bus.$emit('faultDetectionChat')
              this.$swal({
                title: this.$t('success'),
                text: this.$t('deleted'),
                icon: 'success'
              })
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('deleteFailed'),
                icon: 'error'
              })
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              })
            }
          }).finally(() => {
            loader.hide()
          })
        }
      })
    },
    show() {
      if (this.id) {
        let loader = this.$loading.show()
        this.data = []
        this.$service.get(`${this.service}/detail/${this.id}`).then(response => {
          if (response && response.data) {
            this.data = response.data
          }
          this.showDetailModel = true
          loader.hide()
        })
      }
    },
    getContent(item) {
      let content = item.content
      if (!content || !item.keywords || !item.keywords.length) {
        return content
      }
      content = content.toLowerCase()
      item.keywords.forEach(keyword => {
        content = content.replaceAll(keyword, `<span class='text-warning text-underline' style='text-decoration: underline'>${keyword}</span>`)
      })
      return content
    }
  },
  i18n: {
    messages: {
      en: {
        content: 'Content',
        skip: 'Skip',
        lockClient: 'Are you sure this customer is violating policy?',
        deleteConfirm: 'Confirm the customer is not infringing',
        lockSuccess: 'Confirm lock customer, send notification email and notify admin',
        close: 'Close',
        chats: 'Chats',
        incomingMessage: 'Incoming message',
        outgoingMessage: 'Outgoing message',
        customer: 'Customer',
        source: 'Source'
      },
      vi: {
        content: 'Nội dung',
        skip: 'Bỏ qua',
        lockClient: 'Bạn chắc chắc xác định khách hàng này đang vi phạm chính sách?',
        deleteConfirm: 'Xác nhận khách hàng không vi phạm, bỏ qua nghi ngờ?',
        lockSuccess: 'Xác nhận khoá khách hàng, gửi email thông báo và thông báo đến admin',
        close: 'Đóng',
        chats: 'Danh sách tin nhắn nghi ngờ vi phạm',
        incomingMessage: 'Tin nhắn đến',
        outgoingMessage: 'Tin nhắn đi',
        customer: 'Khách hàng',
        source: 'Nguồn'
      }
    }
  }
}
</script>